import React from 'react';
import cx from 'classnames';

import Avatar from 'components/Avatar';

export default props => {
  let { user, size, layout = "hor", ...p } = props;
  return (
    <div className={cx("g-user", size, layout)} {...p}>
      <Avatar src={user?.avatarUrl} size={size} />
      <div className="username">{ user?.username }</div>
    </div>);
}